<template>
  <div class="container">
    <div class="title">{{ $t('c2c').OrderHistory }}</div>
    <div class="info">
      <!-- 顶部 -->
      <div class="top">
        <!-- tab切换 -->
        <div class="tabs"><span v-for="(item, index) in tabs" :key="`tab${index}`"
            :class="active == item.value ? 'active' : ''" @click="changeTab(item.value)">{{ item.name }}</span></div>
      </div>
      <!-- 订单列表 -->
      <div class="orderList">
        <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getOrderList"
          :immediate-check="false">
          <div class="item" v-for="(dItem, dIndex) in oList" :key="`order${dIndex}`">
            <div class="name">
              <div class="left"><span :class="dItem.type == 1 ? 'green' : 'red'">{{ dItem.type == 1 ? $t('trade').buyBtn
                : $t('trade').sellBtn }}</span>{{ dItem.currency }}
              </div>
              <!-- 状态 -->
              <div class="status">{{ dItem.status == 1 ? $t('c2c').inprogress : dItem.status == 2 ? $t('c2c').Completed
                : dItem.status == 3 ? $t('c2c').Cancelled : '' }}</div>
            </div>
            <!-- 数量 -->
            <div class="lable">{{ $t('c2c').quantity }}<span>{{ dItem.quantity }} {{ dItem.currency }}</span></div>
            <!-- 单价 -->
            <div class="lable">{{ $t('c2c').price }}<span>{{ dItem.price }} USD</span></div>
            <!-- 金额 -->
            <div class="lable">{{ $t('c2c').amountmoney }}<span>{{ dItem.amount }} USD</span></div>
            <!-- 订单号 -->
            <div class="lable">{{ $t('c2c').OrderNo }}<span>{{ dItem.orderNo }}<svg-icon class-name="svgs"
                  icon-class="copy" @click="onCopy(dItem.orderNo)" /></span></div>
            <!-- 聊天 时间 -->
            <div class="time">
              <div class="left" @click="$router.push({ name: 'Chat', query: { id: dItem.ctcOrderId } })"><span>{{
                dItem.vendorName }}</span><svg-icon class-name="svgs" icon-class="chat" /></div>
              <span>{{ dItem.applyTime | getLocalTime }}</span>
            </div>
            <!-- 取消 -->
            <div class="btn" v-if="dItem.status == 1"><span @click="toCancelOrder(dItem.ctcOrderId)">{{
              $t('public').cancel }}</span></div>
          </div>
        </van-list>
        <div class="empty" v-if="isEmpty">
          <svg-icon class-name="esvgs" icon-class="empty" />
          <div class="txt">{{ $t('public').emptyTxt }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import orderApi from '@/api/order'

export default {
  data() {
    return {
      isEmpty: false,
      active: "1",
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      oList: [],
    }
  },
  computed: {
    tabs() {
      return [{
        "name": this.$t('c2c').inprogress,
        "value": "1"
      }, {
        "name": this.$t('c2c').Completed,
        "value": "2"
      }, {
        "name": this.$t('c2c').Cancelled,
        "value": "3"
      },
      ]
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getOrderList()
  },
  methods: {
    //切换状态
    changeTab(val) {
      this.active = val
      this.refreshOrderList()
    },
    //复制方法
    onCopy(text) {
      return new Promise((resolve) => {
        if (navigator.clipboard?.writeText) {
          this.$toast(this.$t('public').copySuccess)
          return resolve(navigator.clipboard.writeText(text))
        }
        const textarea = document.createElement('textarea')
        document.body.appendChild(textarea)
        textarea.style.position = 'absolute'
        textarea.style.clip = 'rect(0 0 0 0)'
        textarea.value = text
        textarea.select()
        document.execCommand('copy', true)
        textarea.remove()
        this.$toast(this.$t('public').copySuccess)
        return resolve(true)
      })
    },
    //刷新获取订单列表
    refreshOrderList() {
      this.oList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.getOrderList()
    },
    // 获取订单列表
    async getOrderList() {
      if (this.isRun) return
      this.isEmpty = false
      this.isRun = true
      this.parms.productBusiness = this.activeBusiness
      this.parms.status = this.active
      const res = await orderApi.getCtcOrderList(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      if (this.oList.length == 0) {
        this.isEmpty = true
      } else {
        this.isEmpty = false
      }
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
    // 取消订单确认弹窗
    async toCancelOrder(ctcOrderId) {
      this.$dialog.confirm({
        title: this.$t('position').cancelorder,
        confirmButtonText: this.$t('public').confirm,
        confirmButtonColor: 'var(--text_color)',
        cancelButtonText: this.$t('public').cancel,
        cancelButtonColor: 'var(--ntext_color)',
      })
        .then(() => {
          this.cancelOrder(ctcOrderId)
        })
    },
    // 取消订单
    async cancelOrder(ctcOrderId) {
      await orderApi.cancelCtcOrder({ ctcOrderId: ctcOrderId })
      this.$toast(this.$t('position').Cancelsuccessfully)
      this.refreshOrderList()
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .title {
    font-size: 36px;
    font-weight: bold;
    color: var(--text_color);
    margin: 0 auto;
    max-width: 1280px;
    padding-bottom: 40px;
  }

  .info {
    margin: 0 auto;
    max-width: 1280px;

    .top {
      width: 100%;
      background: var(--background_color);

      .tabs {
        font-size: 16px;
        color: var(--ntext_color);
        border-bottom: 1px solid var(--info_color);
        display: flex;
        align-items: center;

        span {
          padding: 12px 0;
          margin-right: 30px;
        }

        .active {
          color: var(--text_color);
          font-weight: bold;
          padding-bottom: 10px;
          border-bottom: 2px solid var(--text_color);
        }
      }
    }

    .orderList {
      margin-bottom: 30px;

      .item {
        padding: 15px;
        color: var(--text_color);
        font-size: 13px;
        border-bottom: 1px solid var(--info_color);

        .name {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .left {
            font-size: 16px;
            color: var(--text_color);

            span {
              margin-right: 5px;
            }
          }

          .status {
            background: var(--info_color);
            color: var(--ntext_color);
            font-size: 12px;
            padding: 5px 10px;
            border-radius: 5px;
          }
        }

        .lable {
          margin-top: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          color: var(--ntext_color);

          span {
            color: var(--text_color);
          }

          .svgs {
            margin-left: 5px;
            width: 15px;
            height: 15px;
            color: var(--ntext_color);
          }
        }

        .time {
          margin-top: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 15px;
          color: var(--ntext_color);

          .left {
            display: flex;
            align-items: center;
            background: var(--info_color);
            color: var(--text_color);
            font-size: 15px;
            padding: 5px;
            border-radius: 5px;

            &:hover {
              opacity: 0.8;
            }

            span {
              max-width: 170px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .svgs {
              margin-left: 5px;
              width: 15px;
              height: 15px;
              color: var(--text_color);
            }
          }
        }

        .btn {
          margin-top: 10px;
          display: flex;
          justify-content: right;

          span {
            padding: 5px 30px;
            border-radius: 15px;
            font-size: 12px;
            font-weight: normal;
            color: var(--background_color);
            background: var(--text_color);

            &:hover {
              opacity: 0.8;
            }
          }
        }
      }

      .empty {
        margin-top: 50px;
        text-align: center;

        .esvgs {
          width: 50px;
          height: 50px;
        }

        .txt {
          margin-top: 30px;
          font-size: 12px;
          color: var(--text_color);
        }
      }
    }
  }
}


::v-deep .van-popup--bottom {
  border-radius: 15px 15px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup--center {
  border-radius: 15px;
  background: var(--background_color);
}

::v-deep .van-popup__close-icon {
  font-size: 18px;
  color: var(--ntext_color);
}


::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

::v-deep .van-field__label {
  margin-right: 5px;
  display: flex;
  align-items: center;
  color: var(--ntext_color);
  width: auto;
  font-size: 12px;
  font-weight: normal;
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: var(--ntext_color);
}

::v-deep .van-cell {
  background: var(--background_color);
  border: 1px solid var(--info_color);
  border-radius: 10px;
  padding: 0 10px;
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
  height: 40px;
}
</style>
